import View from 'cdna/core/view';
import VideoLineView from './videoLineView.js';  
import markup from './videoGroupView.html';

export default View.extend({
    el: markup,
    bindings: {
        'Title [data-bind=group-title]': 'text',
        'durationDescription [data-bind=group-duration]': 'text',
        'Videos [data-bind=videos]': 'collection videosBinding videosBinding',
        'toggled .toggler': {
            changeElement(el, val) {
                if (val) el.addClass('active').removeClass('inactive');
                else el.addClass('inactive').removeClass('active');
            }
        },
        'toggled [data-bind=videos]': 'visibility'
    },        
    videosBinding: {
        itemView: VideoLineView
    },
    events: {
        'click .toggler': 'toggleVisibility'
    },
    toggleVisibility() {
        this.model.set('toggled', !this.model.get('toggled'));
    }
});


/** WEBPACK FOOTER **
 ** ./client/video/videoGroupView.js
 **/